import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "PageModal" }

import LfForm from '@/components/lf-form.vue'
import { createPageData, editPageData } from '@/service/main/system'
import { useStore } from '@/store'
import {
  withDefaults,
  ref,
  computed,
  useSlots,
  watch
} from 'vue'
import { IForm } from './types'
import { ElLoading } from 'element-plus'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'


export default /*#__PURE__*/_defineComponent({
  __name: 'PageModal',
  props: {
    modalConfig: {},
    defaultInfo: { default: {} },
    pageName: {},
    title: {},
    width: { default: '30%' },
    submitShow: { type: Boolean, default: true },
    url: {},
    otherInfo: { default: {} },
    watchDeep: { type: Boolean },
    validOtherInfo: { type: Function, default: () => true },
    refreshPage: { type: Function, default: () => false }
  },
  emits: ["updateBatchData", "select", "change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const slots = useSlots()
const dialogVisible = ref(false)
const isBatch = ref(false)
const isAdd = ref(false)
const props = __props

const emit = __emit

const handleSelect = (item: any) => {
  emit('select', item)
}

const changeSelect = (item: any, value: any,formData:any) => {
  emit('change', item, value,formData)
}
// 只保留自定义插槽（匹配 field-xxx 格式）
const filteredSlots = computed(() => {
  const slotObj = { ...slots }
  const obj =Object.fromEntries(
    Object.entries(slotObj).filter(([slotName]) => slotName.startsWith('field-'))
  )
  return obj
})

const formData = ref<any>({})
const confirmLoading = ref(false)

watch(
  () => props.defaultInfo,
  (newValue) => {
    for (const item of props.modalConfig.formItems) {
      formData.value[`${item.field}`] = newValue[`${item.field}`]
    }
  },
  { deep: props.watchDeep, immediate: true }
)

const lfFormRef = ref<InstanceType<typeof LfForm>>()
const store = useStore()

const handleCancleClick = () => {
  confirmLoading.value = false
  dialogVisible.value = false
}

const handleConfirmClick = () => {
  confirmLoading.value = true
  lfFormRef.value?.validate(async (isValid) => {
    //可能传进来一个promise
    let parentValid = await props.validOtherInfo()

    if (isValid && parentValid) {
      if (isBatch.value) {
        emit('updateBatchData', { ...formData.value })
      } else {
        if (Object.keys(props.defaultInfo).length && !isAdd.value) {
          // 编辑
          let pageUrl = `/main/${props.pageName}/${props.defaultInfo.id}`
          if (props.url) {
            pageUrl = props.url
          }
          try {
            await editPageData(pageUrl, {
              ...formData.value,
              ...props.otherInfo
            })
            if (!props.refreshPage()) {
              let loadingInstance: ILoadingInstance = {} as ILoadingInstance
              if (document.querySelector('.el-table__body-wrapper')) {
                loadingInstance = ElLoading.service({
                  target: '.el-table__body-wrapper',
                  text: '加载中....',
                  spinner: 'el-icon-loading',
                  background: 'rgba(255, 255, 255, 0.8)',
                  fullscreen: false
                })
              }
              store
                .dispatch('system/getPageListAction', {
                  pageName: props.pageName,
                  queryInfo: store.state.system.queryInfo
                })
                .then(() => {
                  if (
                    loadingInstance &&
                    typeof loadingInstance.close == 'function'
                  ) {
                    loadingInstance.close()
                  }
                })
                .finally(() => {
                  if (
                    loadingInstance &&
                    typeof loadingInstance.close == 'function'
                  ) {
                    loadingInstance.close()
                  }
                })
            }
            dialogVisible.value = false
          } finally {
            confirmLoading.value = false
          }
        } else {
          // 新建
          let pageUrl = `/main/${props.pageName}/add`
          if (props.url) {
            pageUrl = props.url
          }
          try {
            await createPageData(pageUrl, {
              ...formData.value,
              ...props.otherInfo
            })
            if (!props.refreshPage()) {
              store.dispatch('system/getPageListAction', {
                pageName: props.pageName,
                queryInfo: store.state.system.queryInfo
              })
            }
            dialogVisible.value = false
          } finally {
            confirmLoading.value = false
          }
        }
      }
    } else {
      confirmLoading.value = false
    }
  })
}

__expose({
  dialogVisible,
  confirmLoading,
  isBatch,
  lfFormRef,
  formData,
  isAdd
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      title: _ctx.title,
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
      width: props.width,
      center: "",
      "destroy-on-close": "",
      "close-on-click-modal": false
    }, _createSlots({
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "header", {
          row: props.defaultInfo
        }),
        _createVNode(LfForm, _mergeProps(_ctx.modalConfig, {
          modelValue: formData.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event)),
          ref_key: "lfFormRef",
          ref: lfFormRef,
          onSelect: handleSelect,
          onChange: changeSelect
        }), _createSlots({ _: 2 }, [
          _renderList(filteredSlots.value, (slot, slotName) => {
            return {
              name: slotName,
              fn: _withCtx((slotProps) => [
                _renderSlot(_ctx.$slots, slotName, _normalizeProps(_guardReactiveProps(slotProps)))
              ])
            }
          })
        ]), 1040, ["modelValue"]),
        _renderSlot(_ctx.$slots, "default"),
        _renderSlot(_ctx.$slots, "other", { show: dialogVisible.value })
      ]),
      _: 2
    }, [
      (_ctx.submitShow)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createVNode(_component_el_button, { onClick: handleCancleClick }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: handleConfirmClick,
                loading: confirmLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["title", "modelValue", "width"])
  ]))
}
}

})